import React from "react";
import { Polygon } from "@react-google-maps/api";
import { compose } from "recompose";
import { connect } from "react-redux";
import { createPolygonCoordinates, getColorForShape } from "./helpers";
import { no_op } from 'utilities';
import { setExploreSelectedShapeId } from 'store/actions';
import { shapeFields } from "./shapeFields";

function getPolygonOptions(mapType) {
  const mapViewPolygonOptions = {
    fillColor: `#2b579e`,
    fillOpacity: 0.3,
    strokeWeight: 3,
    strokeColor: `#2b579e`,
    clickable: false,
    zIndex: 1000
  }
  const satelliteViewPolygonOptions = {
    fillColor: `#b1b100`,
    fillOpacity: 0.3,
    strokeWeight: 3,
    strokeColor: `#e4e400`,
    clickable: false,
    zIndex: 1000
  }
  return mapType === 'satellite' || mapType === 'hybrid' ? satelliteViewPolygonOptions : mapViewPolygonOptions;
}

function Shape({ shape, shapesData, shapesColoringType, shapesColoringDataType, onClick = no_op, selected = false,
  clickable, shapeColorPalette, strokeWeight, fillOpacity, onRightClick, isHighlighted, ...props }) {
  const coords = createPolygonCoordinates(shape);
  if (coords) {
    const handleClick = () => onClick(shape.id, true);
    const colorMatrix = getColorForShape(shapeColorPalette, shape, shapesData, shapesColoringType, shapesColoringDataType);
    return (
      <Polygon
        // key={`${clickable}`}
        paths={coords}
        options={{
          clickable,
          fillColor: isHighlighted ? '#fff700' : colorMatrix.valueColor,
          fillOpacity: Math.min((selected ? 1.25 : 1) * (fillOpacity ?? 0.7), 1),
          strokeColor: isHighlighted ? '#fff700' : colorMatrix.valueColor,
          strokeOpacity: selected ? 1 : 0.85,
          strokeWeight: isHighlighted ?  10 : selected ? 5 : strokeWeight ?? 1
        }}
        onClick={handleClick}
        // onRightClick={onRightClick}
        {...props}
      />
    )
  } else {
    return null;
  }
}

function CustomShape({ shape, mapType }) {
  const coords = shape.coords;
  if (coords) {
    return (
      <Polygon
        paths={coords}
        options={getPolygonOptions(mapType)}
      />
    )
  } else {
    return null;
  }
}

function ShapeManager({
  setExploreSelectedShapeId,
  customShape,
  mapType,
  selectedShapeId,
  shapesDataObjects,
  activeDrawingObject,
  activeEditingObject,
  highlightedObjectId
}) {
  // const notClickableTypes = ['DistanceMeasuring', 'Label']
  // const type = activeDrawingObject?.type || activeEditingObject?.type;
  // const isClickable = !notClickableTypes.includes(type);
  const isDrawing = activeDrawingObject != null || activeEditingObject != null;

  let customShapeComponent = null;
  // if (shapesGeoType && shapes && shapes.length > 0) {
  const joined = [];
  Object.keys(shapesDataObjects).forEach(objectId => {
    const { shapesData, coloringType, isVisible, customPalette, strokeWeight,
      fillOpacity, index } = shapesDataObjects[objectId];
    const dataType = shapeFields.find(field => field.dataField === coloringType)?.dataType;
    shapesData.forEach(shape => {
      const selected = shape.id === selectedShapeId;
      joined.push(<Shape
        shape={shape}
        key={objectId + shape.id}
        onClick={shapeId => setExploreSelectedShapeId(objectId, shapeId, true)}
        shapesData={shapesData}
        selected={selected}
        shapesColoringType={coloringType}
        shapesColoringDataType={dataType}
        clickable={!isDrawing}
        shapeColorPalette={customPalette}
        strokeWeight={strokeWeight}
        fillOpacity={fillOpacity}
        isHighlighted={highlightedObjectId === objectId}
        visible={isVisible}
        zIndex={index + 1}
      />);
    });
  })
  // }
  if (customShape) {
    customShapeComponent = <CustomShape shape={customShape} mapType={mapType}/>
  }
  return (
    <>
      {joined}
      {customShapeComponent}
    </>
  )
}

function mapState({ exploreMap, exploreShapesData, exploreViews }) {
  return {
    selectedShapeId: exploreShapesData.selectedShapeId,
    customShape: exploreMap.customShape,
    mapType: exploreMap.mapType,
    shapesDataObjects: exploreShapesData.shapesDataObjects,
    activeDrawingObject: exploreViews.activeDrawingObject,
    activeEditingObject: exploreViews.activeEditingObject,
    highlightedObjectId: exploreViews.highlightedObjectId
  };
}

const mapDispatch = {
  setExploreSelectedShapeId
}

export default compose(
  connect(mapState, mapDispatch)
)(ShapeManager);
